import { Injectable } from '@angular/core';
import { BaseStateExtension } from '@common/state/state-extension';
import { AttachmentDto } from 'src/app/shared/models/attachment/attachment-dto.model';
import { AttachmentModelName } from 'src/app/shared/models/model-names';

export const PROOFS_ATTACHMENT_LIST_STATE_NAME = 'ProofsAttachmentListState';
@Injectable({ providedIn: 'root' })
export class ProofsAttachmentStateExtension extends BaseStateExtension<AttachmentDto> {
  name: string = AttachmentModelName;

  public idToObserve: string;
  public patientIdToObserve: string | null = null;

  public async canBeStored(item: AttachmentDto): Promise<boolean> {
    if (!this.patientIdToObserve || !item || item.metadata.archived || !item.metadata.patientId) {
      return false;
    }
    return item.metadata.patientId === this.patientIdToObserve;
  }
  protected async afterCreateInternal(item: AttachmentDto) {
    await this.stateRegistry.createBySync(AttachmentModelName, PROOFS_ATTACHMENT_LIST_STATE_NAME, item);
  }
  protected async afterUpdateInternal(item: AttachmentDto) {
    await this.stateRegistry.updateBySync(AttachmentModelName, PROOFS_ATTACHMENT_LIST_STATE_NAME, [item]);
  }
  protected async removeFromState(item: AttachmentDto) {
    await this.stateRegistry.removeBySync(AttachmentModelName, PROOFS_ATTACHMENT_LIST_STATE_NAME, [item]);
  }
}
